import { toast } from "sonner"
import NetworkIcon from "@/src/assets/icons/ic_low_network.svg?react"

import { Stack, Typography } from "@mui/material"

let toastId: string | number | undefined

const BadInternetToast = () => {
    return (
        <Stack
            sx={{ backgroundColor: "#172B4D", borderRadius: 1, p: 2, color: "#DFE1E6" }}
            direction="row"
            alignItems="center"
            spacing="12px"
            minWidth="300px"
        >
            <NetworkIcon />
            <Stack gap={0}>
                <Typography variant="body2" fontWeight={600}>
                    Your Internet connection is poor
                </Typography>
                <Typography variant="caption">Please check your internet & retry</Typography>
            </Stack>
        </Stack>
    )
}

const showBadInternetToast = () => {
    if (toastId) toast.dismiss(toastId)
    toastId = toast.custom((t) => <BadInternetToast />, {
        duration: 15000,
        position: "bottom-center",
        style: {
            marginBottom: "40px",
            ...(window.innerWidth < 768
                ? {
                      width: "calc(100vw - 80px)",
                      minWidth: "340px",
                      maxWidth: "400px",
                      marginLeft: "24px",
                      marginRight: "24px",
                  }
                : { minWidth: "340px" }),
        },
    })
}

const dismissBadInternetToast = () => {
    if (toastId) toast.dismiss(toastId)
}

export { showBadInternetToast, dismissBadInternetToast }
